import ResolverError from "./ResolverError.mjs";
class UnmatchedResolverError extends ResolverError {}
export default UnmatchedResolverError;